import React from "react";
import { connect } from "react-redux";
import { Icon, Layout, Menu } from "antd";
//import logo from '../resources/assets/rh-logo-comp.png';
//import logo from '../resources/assets/stresidences-logo.png';
import { Link, withRouter } from "react-router-dom";
import Auth from "@aws-amplify/auth";
import { setSidebarBreakpoint, toggleSidebar } from "../store/actions/topnav";
import { openNotificationWithIcon } from "../store/notificationService";
import getLogo from "../service/logoFactory";
import getEnv from "../service/getEnv";
// import OwnerPortal from "./OwnerPortal";

const env = getEnv();
const logo = getLogo(env);

class TopNav extends React.Component {
  render() {
    return (
      <Layout.Sider
        breakpoint="lg"
        collapsedWidth="0"
        collapsed={this.props.collapsed}
        onCollapse={(collapsed, type) => {
          if (type === "clickTrigger") {
            this.props.dispatch(toggleSidebar(!this.props.collapsed));
          }
        }}
        onBreakpoint={(broken) => {
          this.props.dispatch(setSidebarBreakpoint(broken));
          if (!broken) {
            this.props.dispatch(toggleSidebar(false));
          }
          if (broken) {
            this.props.dispatch(toggleSidebar(true));
          }
        }}
      >
        <div className="a1"></div>
        <div className="greenshape"></div>
        <div
          className={`logo logo-wrapper-env-${env} ${
            env === "escape2thesands" ? `bg-white` : ``
          }`}
        >
          <img src={logo} alt="" />
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["/"]}
          selectedKeys={[getSelectedKey(this.props.location.pathname)]}
          onSelect={({ key }) => {
            if (key === "/logout") {
              return;
            }
            this.props.breakpoint && this.props.dispatch(toggleSidebar(true));
          }}
          onClick={({ key }) => {
            if (key === "/logout") {
              Auth.signOut()
                .then(() => {
                  this.props.history.push("/");
                  this.props.onStateChange("signedOut", null);
                })
                .catch(() => {
                  openNotificationWithIcon(
                    "error",
                    "Error",
                    "There has been a problem logging you out. Please try again."
                  );
                });
            } else {
              this.props.breakpoint && this.props.dispatch(toggleSidebar(true));
            }
          }}
        >
          <Menu.Item key="/">
            <Link to={"/"}>
              <Icon
                type="home"
                style={{ fontSize: "1.3em" }}
                theme="outlined"
              />
              <span className="nav-text">Dashboard</span>
            </Link>
          </Menu.Item>
          {this.props.portalType === "guest" ? (
            <Menu.Item key="/messages">
              <Link to={"/messages"}>
                <Icon
                  type="book"
                  style={{ fontSize: "1.3em" }}
                  theme="outlined"
                />
                <span className="nav-text">Notifications</span>
              </Link>
            </Menu.Item>
          ) : null}
          {this.props.portalType === "guest" ? (
            <Menu.Item key="/maintenance">
              <Link to={"/maintenance"}>
                <Icon
                  type="tool"
                  style={{ fontSize: "1.3em" }}
                  theme="outlined"
                />
                <span className="nav-text" style={{ fontSize: "0.95em" }}>
                  Maintenance Requests
                </span>
              </Link>
            </Menu.Item>
          ) : null}
          {this.props.portalType === "guest" ? (
            <Menu.Item key="/bills">
              <Link to={"/bills"}>
                <Icon
                  type="bar-chart"
                  style={{ fontSize: "1.3em" }}
                  theme="outlined"
                />
                <span className="nav-text">Payments</span>
              </Link>
            </Menu.Item>
          ) : null}
          {this.props.portalType === "guest" && this.props.stripeEnabled ? (
            <Menu.Item key="/extras">
              <Link to={"/extras"}>
                <Icon
                  type="shopping-cart"
                  style={{ fontSize: "1.3em" }}
                  theme="outlined"
                />
                <span className="nav-text">Extras</span>
              </Link>
            </Menu.Item>
          ) : null}
          {this.props.portalType === "guest" ? (
            <Menu.Item key="/apartments">
              <Link to={"/apartments"}>
                <Icon
                  type="layout"
                  style={{ fontSize: "1.3em" }}
                  theme="outlined"
                />
                <span className="nav-text">Apartment</span>
              </Link>
            </Menu.Item>
          ) : null}

{this.props.portalType === "owner" ? (
            <Menu.Item key="/bookings">
              <Link to={"/bookings"}>
                <Icon
                  type="schedule"
                  style={{ fontSize: "1.3em" }}
                  theme="outlined"
                />
                <span className="nav-text">Bookings</span>
              </Link>
            </Menu.Item>
          ) : null}
          {this.props.portalType === "owner" &&
            (window.location.host.includes("staging") || window.location.host.includes("domusstay")) ? (
            <Menu.Item key="/bookings-create">
              <Link to={"/bookings-create"}>
                <Icon
                  type="plus"
                  style={{ fontSize: "1.3em" }}
                  theme="outlined"
                />
                <span className="nav-text">Create Booking</span>
              </Link>
            </Menu.Item>
          ) : null}
          {this.props.portalType === "owner" ? (
            <Menu.Item key="/statements">
              <Link to={"/statements"}>
                <Icon
                  type="file-text"
                  style={{ fontSize: "1.3em" }}
                  theme="outlined"
                />
                <span className="nav-text" style={{ fontSize: "0.95em" }}>
                  Statements
                </span>
              </Link>
            </Menu.Item>
          ) : null}
          <Menu.Divider />
          <Menu.Item key="/logout">
            <Icon type="api" style={{ fontSize: "1.3em" }} theme="outlined" />
            <span className="nav-text">Logout</span>
          </Menu.Item>
        </Menu>
      </Layout.Sider>
    );
  }
}

const getSelectedKey = (pathname) => {
  if (pathname === "/" || pathname === "") {
    return pathname;
  }
  if (pathname.split("/").length > 2) {
    const split = pathname.split("/");
    return `/${split[1]}`;
  }
  return pathname;
};

const mapStateToProps = (state) => {
  return {
    collapsed: state.navigation.sideMenuCollapsed,
    breakpoint: state.navigation.sideMenuBreakpoint,
    portalType: state.global.portalType,
    stripeEnabled: state.global.stripeEnabled
  };
};

export default withRouter(connect(mapStateToProps)(TopNav));
